import { rememberIdentity } from './identity';
import type { ClientMsg, PosFields } from '../../../shared/protocol';

// 서버 연결 전담: 접속, 송수신, 재연결, ping, pos 송신 제한. 게임 상태는 모른다.
export const Net = (() => {
  const RETRY = [1000, 2000, 4000, 8000, 10000], PING = 25000, POS_GAP = 50;
  let ws: WebSocket | null = null, url = '', hello: () => ClientMsg, on: any = {}, fails = 0, ready = false, full = false, retry: any = 0, ping: any = 0, lastPos = '', lastAt = 0;

  const raw = (s: string) => { if (ws && ws.readyState === 1) ws.send(s); };
  const send = (obj: ClientMsg) => { if (ready) raw(JSON.stringify(obj)); return ready; };   // 연결이 없으면 버리고 false

  function open() {
    clearTimeout(retry);
    let w: WebSocket;
    try { w = ws = new WebSocket(url); } catch (e) { return lost(); }
    w.onopen = () => { raw(JSON.stringify(hello())); clearInterval(ping); ping = setInterval(() => raw('{"t":"ping"}'), PING); };
    w.onmessage = (ev) => {
      if (ws !== w) return;
      let m: any; try { m = JSON.parse(ev.data); } catch (e) { return; }
      if (!m || typeof m.t !== 'string') return;
      if (m.t === 'welcome') { rememberIdentity(m.pid, m.token); ready = true; fails = 0; lastPos = ''; }
      if (m.t === 'full') full = true;
      if (on[m.t]) on[m.t](m);
    };
    w.onclose = () => { if (ws === w) lost(); };
  }

  function lost() {
    clearInterval(ping); ready = false;
    if (full) return;
    fails++;
    if (on.close) on.close({ fails });
    retry = setTimeout(open, RETRY[Math.min(fails, RETRY.length) - 1]);
  }

  return {
    send,   // 이미 만들어진 메시지 하나. 연결이 없으면 버리고 false를 돌려준다
    // room: 초대 링크 방 이름, helloFn: join 메시지를 돌려주는 함수, handlers: 메시지 종류 t → 처리 함수 (close는 연결이 끊길 때)
    start(room: string, helloFn: () => ClientMsg, handlers: any) {
      this.stop();
      url = (location.protocol === 'https:' ? 'wss:' : 'ws:') + '//' + location.host + '/ws?room=' + encodeURIComponent(room);
      hello = helloFn; on = handlers; fails = 0; full = false;
      open();
    },
    stop() { clearTimeout(retry); clearInterval(ping); ready = false; const w = ws; ws = null; if (w) w.close(); },
    // 위치는 같은 값이면 보내지 않고, 50ms(초당 20번)보다 자주 보내지 않는다
    sendPos(p: PosFields) {
      if (!ready) return;
      const s = JSON.stringify(p), now = performance.now();
      if (s === lastPos || now - lastAt < POS_GAP) return;
      lastPos = s; lastAt = now; send({ t: 'pos', ...p });
    },
    // 장소를 떠났다는 알림: 같은 값 dedup(lastPos)을 지워 다시 돌아와 같은 자리에 나타나도 pos가 나간다
    sendAway() { lastPos = ''; send({ t: 'away' }); },
    get online() { return ready; },
  };
})();
